"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../../container"));
var player_1 = require("../../stores/player");
var checkRequiredPlayState_1 = __importDefault(require("./checkRequiredPlayState"));
var player_2 = require("../../selectors/player");
function setPlayState(playState) {
    var action = function (dispatch, getState) {
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/setPlayState");
        var state = getState();
        logger.info("Updating play state", {
            playState: playState,
            requiredPlayState: (0, player_2.selectRequiredPlayState)(state),
            currentPlayState: (0, player_2.selectCurrentPlayState)(state),
        });
        dispatch((0, player_1.setRequiredPlayState)(playState));
        dispatch((0, checkRequiredPlayState_1.default)());
        dispatch({ type: setPlayState.type });
    };
    action.type = setPlayState.type;
    return action;
}
setPlayState.type = "setPlayState";
exports.default = setPlayState;
//# sourceMappingURL=setPlayState.js.map